module.exports = __webpack_public_path__ + "static/media/Ticket_white.296ffeff.svg";